var Surveys = new (class Surveys extends AbstractModule {

  constructor() {
    super("Surveys");
  }

  _initData(data) {
    this._autoInit({
      "_surveys_count" : [ data.guest.surveys ? data.guest.surveys.length : null, 0 ],
      "_surveys"       : [ data.guest.surveys,[] ] 
    });
  }

  /**
   * enterState
   * @param  {Conversation} conversation
   * @return {Promise}      true: At least one survey has been prompted
   *                        false: No survey was prompted
   */
  async enterState(conversation) {
    return new Promise((resolve, reject) => {
      const hasGuestMessage = conversation.messages.some(m => m.fromVisitor());
      if (this._surveys_count > 0 && hasGuestMessage) {
        Utils.logState(conversation, 'Survey');
        conversation.storePromise(resolve, reject, 'survey');
        this.processNextSurvey(conversation);
      }
      else {
        resolve(false);
      }
    });
  }

  processNextSurvey(conversation) {
    return new Promise((resolve, reject) => {
      if(this._surveys_count > 0) {
        if(conversation.current_survey >= this._surveys_count) {
          conversation.addMessage(new Message(MS.bot, Wording.md('survey_end_text')));

          this.app._triggerInternalEvent('ended_survey', {  });
          conversation.resolvePromise(true, 'survey');
          return null;
        }

        let survey = this._surveys[conversation.current_survey]
        let message;

        switch(survey.kind) {
          case 'yesno':
            message = this.getYesnoSurvey(survey);
            this._attachYesnoInteraction(message, survey);
            break;

          case 'open':
            message = this.getOpenSurvey(survey);
            this._attachOpenInteraction(message, survey);
            break;

          case 'rating':
            message = this.getRatingSurvey(survey);
            this._attachRatingInteraction(message, survey);
            break;
        }

        if (message)
          conversation.addMessage(message);

        this.app._triggerInternalEvent('recieved_survey', { 'message': survey.title });
        conversation.current_survey += 1
      }
    });
  }






  getYesnoSurvey(survey) {
    let message = new Message(MS.bot, `
      <p>
        ${survey.question}
      </p>
      <div id="slaask-yesno">
        <a class="slaask-btn slaask-btn-yes" id="slaask-yesno-yes" data-response="yes">
          ${survey.yes_content}
        </a>
        <a class="slaask-btn slaask-btn-no" id="slaask-yesno-no" data-response="no">
          ${survey.no_content}
        </a>
      </div>`);
    message.plain_text = survey.question;
    return message;
  }

  getOpenSurvey(survey) {
    let message = new Message(MS.bot, `
      <p>
        ${survey.question}
      </p>
      <form id="slaask-open-survey-form">
        <input id="slaask-open-survey-input" name="response" class="slaask-input slaask-input-survey" placeholder="${survey.open_ended_placeholder}" type="text" value=""/>
        <input type="submit" class="slaask-btn" id="slaask-rating-sutmit" value="${survey.rating_submit_content}"/>
      </form>`);
    message.plain_text = survey.question;
    return message;
  }

  getRatingSurvey(survey) {
    const fourChoices = survey.four_choices === true || survey.four_choices === 'true';
    const ratingValues = fourChoices ? [5, 4, 2, 1] : [5, 4, 3, 2, 1];

    let radio = (value, checked) => {
      let emoji= ""
      switch(value){
        case 1:
          emoji= `${this.app._cdn_url}/1f620.png`
        break
        case 2:
          emoji= `${this.app._cdn_url}/1f641.png`
        break
        case 3:
          emoji= `${this.app._cdn_url}/1f610.png`
        break
        case 4:
          emoji= `${this.app._cdn_url}/1f642.png`
        break
        case 5:
          emoji= `${this.app._cdn_url}/1f60d.png`
        break
        
      }
      return `
        <input id="rate_${value}" name="slaask-rating-survey-input" type="radio" required value="${value}"${checked ? ` checked="checked"`: ''} />
        <label for="rate_${value}" >
          <img class="slaask-emoji" src="`+emoji+`"  alt="emoji">
        </label>`
    };

    let message = new Message(MS.bot, `
      <p>
        ${survey.question}
      </p>
      <form id="slaask-rating-survey-form">
        <section class="slaask-rating" id="slaask-rate">
          ${ratingValues.map(v => radio(v, false)).join('')}
        </section>
        <input type="submit" class="slaask-btn" id="slaask-rating-sutmit" value="${survey.rating_submit_content}"/>
      </form>`);
    message.plain_text = survey.question;
    return message;
  }


  _attachYesnoInteraction(message, survey) {
    message.addInteraction({
      selector: '.slaask-btn',
      event: 'click',
      handler: e => {
        Ajax.call('/api/complete_survey', {
          'key': this.app._api_key,
          'guest_id': this.app._guest_id,
          'survey_id': survey.id,
          'response': Utils.dataSet(e.currentTarget, 'response'),
          'current_conversation_id': message.conv_id
        }).then(ajaxData => this._surveyCallback(message.conv_id, ajaxData));
        Utils.removeElement(message.getElement().querySelector('#slaask-yesno'));
      }
    });
  }

  _attachOpenInteraction(message, survey) {
    message.addInteraction({
      selector: '#slaask-open-survey-form',
      event: 'submit',
      handler: e => {
        e.preventDefault();
        Ajax.call('/api/complete_survey', {
          'key': this.app._api_key,
          'guest_id': this.app._guest_id,
          'survey_id': survey.id,
          'response': e.currentTarget.response.value,
          'current_conversation_id': message.conv_id
        }).then(ajaxData => this._surveyCallback(message.conv_id, ajaxData));
        Utils.removeElement(e.currentTarget);
      }
    });
  }

  _attachRatingInteraction(message, survey) {
    message.addInteraction({
      selector: '#slaask-rating-survey-form',
      event: 'submit',
      handler: e => {
        e.preventDefault();
        var like = message.getElement().querySelector('[name=slaask-rating-survey-input]:checked');

        Ajax.call('/api/complete_survey', {
          'key': this.app._api_key,
          'guest_id': this.app._guest_id,
          'survey_id': survey.id,
          'response': like.value,
          'current_conversation_id': message.conv_id
        }).then(ajaxData => this._ratingSurveyCallback(message.conv_id, ajaxData));
        Utils.removeElement(e.currentTarget);
      }
    });
  }


  _surveyCallback(conversationId, data) {
    let conversation = Conversations.get(conversationId);
    if(!data.response == '') {
      conversation.addMessage(new Message(MS.visitor, data.response));
    }
    this.processNextSurvey(conversation);
  }

  _ratingSurveyCallback(conversationId, data) {
    let likes       = parseInt(data.response);
    let likes_html  = '';

    switch(likes){
      case 1:
        likes_html= ":angry:"
      break
      case 2:
        likes_html= ":disappointed:"
      break
      case 3:
        likes_html= ":neutral_face:"
      break
      case 4:
        likes_html= ":slightly_smiling_face:"
      break
      case 5:
        likes_html= ":heart_eyes:"
      break
      
    }

    let conversation = Conversations.get(conversationId);
    let message = new Message(MS.visitor, likes_html);
    message.parser = Message.PARSER.HTML;
    conversation.addMessage(message);

    this.processNextSurvey(conversation);
  }

});
